export const MAX_SESSION_DURATION = 1800000; // 30 minutes in ms

export const URLS = {
  iFrameOrigin: 'https://lightning.warnermediacdn.com',
  iFramePath: {
    DEV: '/cdptest/psmtk/getcdpid.html',
    TEST: '/cdptest/psmtk/getcdpid.html',
    PROD: '/cdp/psmtk/getcdpid.html',
    INTEGRATION: '/cdptest/psmtk/getcdpid.html',
    AUTOMATED_TEST: '/cdptest/psmtk/getcdpid.html',
  },
  cdpSvc: {
    DEV: 'https://dev.cdpsvc.com/v1/reg',
    TEST: 'https://dev.cdpsvc.com/v1/reg',
    PROD: 'https://api.cdpsvc.com/v1/reg',
    INTEGRATION: 'https://dev.cdpsvc.com/v1/reg',
    AUTOMATED_TEST: 'https://dev.cdpsvc.com/v1/reg',
  },
  locate: 'https://geo.ngtv.io/locate',
  featureFlag: {
    DEV: 'https://wmff.warnermediacdn.com/psm_2_dev_full.json',
    TEST: 'https://wmff.warnermediacdn.com/psm_2_qa_full.json',
    PROD: 'https://wmff.warnermediacdn.com/psm_2_prod_full.json',
    INTEGRATION: 'https://wmff.warnermediacdn.com/psm_2_brand_integration_full.json',
    AUTOMATED_TEST: 'https://wmff.warnermediacdn.com/psm_2_automated_test_full.json',
  },
  // privacy: {
  //   DEV: 'https://dev.privacy.api.wmcdp.io/v1/pvc',
  //   TEST: 'https://test.privacy.api.wmcdp.io/v1/pvc',
  //   PROD: 'https://privacy.api.wmcdp.io/v1/pvc',
  //   INTEGRATION: 'https://integration.privacy.api.wmcdp.io/v1/pvc',
  // },
  identity: {
    DEV: 'https://dev.receive.wmcdp.io/v1/reg',
    TEST: 'https://test.receive.wmcdp.io/v1/reg',
    PROD: 'https://receive.wmcdp.io/v1/reg',
    INTEGRATION: 'https://test.receive.wmcdp.io/v1/reg',
    AUTOMATED_TEST: 'https://test.receive.wmcdp.io/v1/reg',
  },
  // telemetry: {
  //   DEV: 'https://dev.telemetry.api.wmcdp.io/v1/tel',
  //   TEST: 'https://test.telemetry.api.wmcdp.io/v1/tel',
  //   PROD: 'https://telemetry.api.wmcdp.io/v1/tel',
  //   INTEGRATION: 'https://integration.telemetry.api.wmcdp.io/v1/tel',
  // },
  idresolve: {
    DEV: 'https://dev.psm.wmcdp.io/v1/resolve',
    TEST: 'https://test.psm.wmcdp.io/v1/resolve',
    PROD: 'https://psm.wmcdp.io/v1/resolve',
    INTEGRATION: 'https://integration.psm.wmcdp.io/v1/resolve',
    AUTOMATED_TEST: 'https://test.psm.wmcdp.io/v1/resolve',
  },
  logs: {
    DEV: 'https://dev.logs.psm.wmcdp.io',
    TEST: 'https://dev.logs.psm.wmcdp.io',
    PROD: 'https://logs.psm.wmcdp.io',
    INTEGRATION: 'https://dev.logs.psm.wmcdp.io',
    AUTOMATED_TEST: 'https://dev.logs.psm.wmcdp.io',
  },
};

export const CCPA_LOCATIONS = ['US', 'PR', 'VI', 'UM', ''];

// Local FF config for FFClient quick init
export const featureFlagLocalConfig = {
  featureFlagLibraryVersion: '0.1',
  flags: [
    {
      defaultValue: true,
      id: 'doppler-identity-onstart',
      cohorts: [],
      name: 'FALLBACK_doppler-identity-onstart',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-identity-oncomplete',
      cohorts: [],
      name: 'FALLBACK_doppler-identity-oncomplete',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-session',
      cohorts: [],
      name: 'FALLBACK_doppler-session',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-privacy',
      cohorts: [],
      name: 'FALLBACK_doppler-privacy',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-telemetry',
      cohorts: [],
      name: 'FALLBACK_doppler-telemetry',
      type: 'boolean',
    },
    {
      defaultValue: true,
      id: 'doppler-consent-update',
      cohorts: [],
      name: 'FALLBACK_doppler-consent-update',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'idresolve',
      cohorts: [],
      name: 'FALLBACK_idresolve',
      type: 'boolean',
    },
    {
      defaultValue: false,
      id: 'sendHHID',
      cohorts: [],
      name: 'FALLBACK_sendHHID',
      type: 'boolean',
    },
  ],
};

// Default flag values in case there's an issue with the FF client
export const featureFlagDefaults = {
  'doppler-identity-onstart': true,
  'doppler-identity-oncomplete': true,
  'doppler-session': true,
  'doppler-privacy': true,
  'doppler-telemetry': true,
  'doppler-consent-update': true,
  idresolve: false,
  sendHHID: false,
  // for unit tests
  'test-enabled': true,
  'test-disabled': false,
};

export const queueOptions = {
  minRetryDelay: 30000,
  maxRetryDelay: 120000,
  maxItems: 5,
  maxAttempts: 10,
  backoffFactor: 2,
  backoffJitter: 0,
};
